// show-errors.component.ts
import { Component, Input } from '@angular/core';
import { AbstractControlDirective, AbstractControl } from '@angular/forms';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'show-errors',
    template: `
   <ul style="margin-left: -19px" *ngIf="shouldShowErrors() || (!shouldShowErrors() && submited)">
     <li style="color: red" *ngFor="let error of listOfErrors()">{{error}}</li>
   </ul>
 `,
})
export class ShowErrorsComponent {

    private static readonly errorMessages = {
        'required': () => 'campo requerido',
        'minlength': (params) => 'El numero minimo de caracteres es :' + params.requiredLength,
        'maxlength': (params) => 'El numero maximo de caracteres es :' + params.requiredLength,
        'pattern': (params) => 'The required pattern is: ' + params.requiredPattern,
        'years': (params) => params.message,
        'countryCity': (params) => params.message,
        'uniqueName': (params) => params.message,
        'telephoneNumbers': (params) => params.message,
        'telephoneNumber': (params) => params.message
    };

    @Input()
    private control: AbstractControlDirective | AbstractControl;
    @Input()
    public submited: Boolean;

    shouldShowErrors(): boolean {
        return this.control &&
            this.control.errors &&
            (this.control.dirty || this.control.touched);
    }

    listOfErrors(): string[] {
        if (this.control.errors != null) {
            return Object.keys(this.control.errors)
                .map(field => this.getMessage(field, this.control.errors[field]));
        } else { return []; }
    }

    private getMessage(type: string, params: any) {
        return ShowErrorsComponent.errorMessages[type](params);
    }

}